import React from 'react';

class CheckboxOption extends React.Component {
  buildCheckbox() {
    const value = this.props.value ? this.props.value : 'on';
    return (
      <input
        className="styled-checkbox"
        type="checkbox"
        name={this.props.name}
        id={this.props.id}
        onClick={this.props.onClick(this.props.index)}
        checked={this.props.checked}
        value={value}
      />
    );
  }

  render() {
    return this.buildCheckbox();
  }
}

export { CheckboxOption };
